// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"DocumentGrid_gridContainer__3vdRP","gridOverlay":"DocumentGrid_gridOverlay__2--7D"};